<template>
  <ManageCreditCardModal
    v-if="isManaging"
    :isWebSubscription="isWebSubscription"
    :isYellowstone="isYellowstone"
    :subscriptionDetails="organizationSubscriptionDetails"
    :apparatusId="apparatusId"
    :apparatusType="apparatusType"
    @switchModal="switchModal"
    @closeGracePeriodModals="closeGracePeriodModals"
  />
  <UpdateCreditCardModal
    v-else
    :existingPaymentInfo="paymentInfo"
    :accountProfile="accountProfile"
    :apparatusId="apparatusId"
    :subscriptionStatus="subscriptionStatus"
    @closeGracePeriodModals="closeGracePeriodModals"
  />
</template>
<script>
import UpdateCreditCardModal from '@/components/Dashboard/UpdateCreditCardModal'
import ManageCreditCardModal from './ManageCreditCardModal.vue'

export default {
  props: [
    'apparatusId',
    'isWebSubscription',
    'isYellowstone',
    'organizationSubscriptionDetails',
    'accountProfile',
    'subscriptionStatus',
    'paymentInfo',
    'apparatusType'
  ],
  components: {
    UpdateCreditCardModal,
    ManageCreditCardModal
  },
  data() {
    return {
      isManaging: true
    }
  },
  methods: {
    switchModal() {
      this.isManaging = false
    },
    closeGracePeriodModals() {
      this.isManaging = true
    }
  }
}
</script>
